import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalHerramientasYControlesPageRoutingModule } from './modal-herramientas-ycontroles-routing.module';

import { ModalHerramientasYControlesPage } from './modal-herramientas-ycontroles.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalHerramientasYControlesPageRoutingModule
  ],
  declarations: [ModalHerramientasYControlesPage]
})
export class ModalHerramientasYControlesPageModule {}
